import { takeEvery } from 'redux-saga';
import { take, select, call, apply } from 'redux-saga/effects';


import * as actions from 'actions/user';
import * as adReview from 'actions/adReview';
import * as editableAd from 'actions/editable-ad';
import * as payments from 'actions/payments';
import * as featureFlags from 'actions/featureFlags';
import * as auth from 'actions/auth';
import * as audienceSizer from 'actions/audienceSizer';
import * as waitlist from 'actions/waitlist';
import * as analytics from 'actions/analytics';

import { getEditableAd, getAdFromCreateForms } from 'selectors/adCreation';
import { getIsAuthenticated } from 'selectors/auth';
import { getFlags } from 'selectors/featureFlags';
import { getUser } from 'selectors/user';
import { getStateTree } from 'selectors/utils';

import debug from 'debug';
const log = debug('sagas:sentry');

export function* watchUserLoginForSentry() {
  const { user: { id, displayName } } = yield take(actions.RECEIVE_USER_INFO);

  log(`setting up the Raven client with the user id: ${id}`);

  window.Raven.setUserContext({
    id,
    username: displayName,
  });
}

export function* updateStateTreeContext(action) {
  const state = yield select(getStateTree);

  window.Raven.setExtraContext({
    state: {
      flags: getFlags(state),
      editableAd: getEditableAd(state),
      reduxForm: getAdFromCreateForms(state),
      auth: {
        isAuthenticated: getIsAuthenticated(state),
      },
      user: getUser(state),
      validation: state.validation,
    },
    lastActionType: action.type,
  });
}

export function* watchActionsForSentryStateLogging() {
  yield take(actions.RECEIVE_USER_INFO);

  log('watching every event to update the state tree context');

  yield call(takeEvery, '*', updateStateTreeContext);
}

export function* logException({ err }, windowObj = window) {
  let error = err;
  const { _LTracker: loggly = [] } = windowObj;
  log('reporting the exception: ', error);

  if (!(err instanceof Error)) {
    log('received a non-error object');
    error = new Error(err);
  }

  yield apply(windowObj.Raven, windowObj.Raven.captureException, [error]);
  yield apply(loggly, loggly.push, {
    type: 'NetworkError',
    context: windowObj.Raven.getContext(),
    error,
  });
}

export function* watchForLoggableErrors() {
  const errorActions = [
    adReview.FETCH_ADS_FAILED,
    adReview.APPROVE_AD_FAILED,
    adReview.REVISE_AD_FAILED,
    adReview.REJECT_AD_FAILED,
    adReview.FETCH_AD_FAILED,
    adReview.CANCEL_AD_FAILED,
    adReview.REFRESH_ADS_FAILED,
    adReview.REVIEW_AUDIO_ADS_FAILED,
    editableAd.CREATE_AD_FAILED,
    payments.ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR,
    featureFlags.FETCH_USER_FLAGS_FAILED,
    auth.SSO_SESSION_ERROR,
    audienceSizer.FETCH_AUDIENCE_SIZE_FAILED,
    waitlist.SUBMIT_WAITLIST_FORM_FAILED,
    analytics.GA_PARTNER_ID_FETCH_FAILED,
  ];

  log('watching for all of the following error actions: ', errorActions);
  yield call(takeEvery, errorActions, logException);
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/sentry.js